import $ from "jquery";

var $background = $('.background-container');

function windowSize() {
  return {
    width: $background.width(),
    height: $background.height()
  };
}

var resizeStream = $(window).asEventStream('resize').map(windowSize);

export default {
  stream: resizeStream,
  property: resizeStream.toProperty(windowSize())
};



// WEBPACK FOOTER //
// ./web/js/resize.js